module.exports = __webpack_public_path__ + "img/icon_sb_checkmark_green.8aae10f.svg";